import { render } from "./Checkouts.vue?vue&type=template&id=bb7b5f18&scoped=true"
import script from "./Checkouts.vue?vue&type=script&lang=js"
export * from "./Checkouts.vue?vue&type=script&lang=js"

import "./Checkouts.vue?vue&type=style&index=0&id=bb7b5f18&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7b5f18"]])

export default __exports__